import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class DataStreamService {
	base_url = DDP_ENV.baseUrl;
	deviceTypeBaseUrl = DDP_ENV.deviceTypeBaseUrl;
	constructor(private _router: Router, private _http: Http, private cookieService: CookieService){}

	/* Get user datastreams */
	getUserDataStreams(userId: string):Observable<any>{
		return this._http.get(this.base_url + '/user/' + userId + '/data-stream', this.buildHeaders())
		             .map((res:Response) => res.json()); /* .toPromise()
                  .then(res => res.json());*/
	}

	/* Get user datastreams */
	getCampaignDataStreams(campaignId: string):Observable<any>{
		return this._http.get(this.deviceTypeBaseUrl + '/campaign/' + campaignId + '/data-stream', this.buildHeaders())
			.map((res:Response) => res.json()); /* .toPromise()
                  .then(res => res.json());*/
	}

	/* Get campaign + deviceId datastreams */
	getCampaignDataStreamsByDeviceId(campaignId: string, deviceId):Observable<any>{
		return this._http.get(this.deviceTypeBaseUrl + '/campaign/' + campaignId + '/device/' + deviceId + '/data-stream', this.buildHeaders())
			.map((res:Response) => res.json()); /* .toPromise()
                  .then(res => res.json());*/
	}

	/* Build request header */
	private buildHeaders(): any {
    	var headers = new Headers({'Authorization': 'Bearer '+ this.cookieService.get('ecare_access_token')
      , "client-id": localStorage.getItem('clientId')});
    	return new RequestOptions({ headers: headers });
  	}
}
